module.exports = __webpack_public_path__ + "img/5.16a9de01.jpg";